import axiosInstance from './axiosConfig';

const buildRailsParams = (filters = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v !== "" && v !== null && v !== undefined) {
          searchParams.append(`filters[${key}][]`, v);
        }
      });
    } else if (value !== "" && value !== null && value !== undefined) {
      searchParams.append(`filters[${key}]`, value);
    }
  });

  return searchParams.toString();
};


const fetchAdsData = async (endpoint, params) => {
  // const marketplaceAcc = JSON.parse(localStorage.getItem("marketplaceAcc") || "{}");
  const filterParams = params.filter;
  const queryParams = {
    // marketplace_id: marketplaceAcc.id,
    start_date: params.formattedStart,
    end_date: params.formattedEnd,
    campaign_ids: params.campaign_id,
    ad_group_ids: params.adgroup_id,
    targeting: params.targeting,
    search_terms: params.search_term,
    customer_search_term:params.customer_search_term,
    product_ids: params.products,
    // Stringify filters if they exist
    ...(filterParams && {
      ads_type: filterParams.ads_type,
      status: filterParams.status,
      brand: filterParams.brand,
      spend: filterParams.spend,
      search_term: filterParams.searchTerm,
      match_types: filterParams.matchTypes,
      clicks: filterParams.clicks,
      sales: filterParams.sales
    }),
  };

  const response = await axiosInstance.get(`/ads/search_term/${endpoint}`, {
    params: queryParams
  });

  return response.data;
};

// --- Exported API Methods ---

export const getCampaignApi = (params) => fetchAdsData('campaigns', params);

export const getAddGroupApi = (params) => fetchAdsData('adgroups', params);

export const getProductApi = (params) => fetchAdsData('product_data', params);

export const getTargetApi = (params) => fetchAdsData('targetings', params);

export const getSearchApi = (params) => fetchAdsData('search_terms', params);
 
export const getCustomerSearchApi = (params) => fetchAdsData('customer_search_term', params);

export const getCampaignFilter = async () => {
  const response = await axiosInstance.get(`/ads/search_term/filters`);
  return response.data;
};